import { render, staticRenderFns } from "./CollectedFileTable.vue?vue&type=template&id=3598c9ad&scoped=true&"
import script from "./CollectedFileTable.vue?vue&type=script&lang=ts&"
export * from "./CollectedFileTable.vue?vue&type=script&lang=ts&"
import style0 from "./CollectedFileTable.vue?vue&type=style&index=0&id=3598c9ad&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3598c9ad",
  null
  
)

export default component.exports